/* eslint-disable linebreak-style */
/* eslint-disable import/extensions */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable-next-line no-unused-vars */
import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

import ScrollToTop from "parts/ScrollToTop";
import ScrollProgressBar from "parts/ScrollProgressBar";

import "./assets/css/styles.css";

// Lazy load all page components for code splitting
const LandingPageNew = lazy(() => import("pages/LandingPage_New"));
const ProjectPage = lazy(() => import("pages/ProjectPage"));
const ServicesPage = lazy(() => import("pages/ServicesPage"));
const AboutPage = lazy(() => import("pages/AboutPage"));
const BlogsPage = lazy(() => import("pages/BlogsPage"));
const BlogDetailPage = lazy(() => import("pages/BlogDetailPage"));
const NotFoundPage = lazy(() => import("pages/NotFoundPage"));
const ProjectDetailPage = lazy(() =>
  import("pages/ProjectDetailPage").then((module) => ({
    default: module.ProjectDetailPage,
  })),
);
const DiscussProjectPage = lazy(() =>
  import("pages/DiscussProjectPage").then((module) => ({
    default: module.DiscussProjectPage,
  })),
);
const VCardPage = lazy(() => import("pages/VCardPage"));
const AIServicePage = lazy(() => import("pages/services/AIServicePage"));
const WebDevServicePage = lazy(
  () => import("pages/services/WebDevServicePage"),
);
const MobileAppServicePage = lazy(
  () => import("pages/services/MobileAppServicePage"),
);
const EnterpriseServicePage = lazy(
  () => import("pages/services/EnterpriseServicePage"),
);
const UIUXServicePage = lazy(() => import("pages/services/UIUXServicePage"));
const SEOServicePage = lazy(() => import("pages/services/SEOServicePage"));
const ITStrategyConsultingPage = lazy(
  () => import("pages/services/ITStrategyConsultingPage"),
);
const LegacyModernizationPage = lazy(
  () => import("pages/services/LegacyModernizationPage"),
);
const MaintenanceSupportPage = lazy(
  () => import("pages/services/MaintenanceSupportPage"),
);
const ProjectManagementPage = lazy(
  () => import("pages/services/ProjectManagementPage"),
);

// Loading component shown while page chunks load
function LoadingFallback() {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <div className="text-center">
        <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-theme-blue"></div>
        <p className="mt-4 text-gray-600">Loading...</p>
      </div>
    </div>
  );
}

function App() {
  return (
    <HelmetProvider>
      <ScrollToTop />
      <ScrollProgressBar />
      <Suspense fallback={<LoadingFallback />}>
        <Routes>
          <Route path="/" element={<LandingPageNew />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/project" element={<ProjectPage />} />
          <Route path="/service" element={<ServicesPage />} />
          <Route path="/blogs" element={<BlogsPage />} />
          {/* Paginated index. Page numbers live in the URL so every post is
              reachable by a crawler; /blogs is page 1. Each page is prerendered
              (see scripts/seo-manifest.mjs) and unknown page numbers 404. */}
          <Route path="/blogs/page/:page" element={<BlogsPage />} />
          <Route path="/blogs/:id" element={<BlogDetailPage />} />
          <Route exact path="/project/:id" element={<ProjectDetailPage />} />
          <Route exact path="/contact-us" element={<DiscussProjectPage />} />
          <Route exact path="/vcard" element={<VCardPage />} />

          <Route path="/service/ai-development" element={<AIServicePage />} />
          <Route
            path="/service/web-development"
            element={<WebDevServicePage />}
          />
          <Route
            path="/service/mobile-development"
            element={<MobileAppServicePage />}
          />
          <Route
            path="/service/enterprise-software-development"
            element={<EnterpriseServicePage />}
          />
          <Route path="/service/ui-ux-design" element={<UIUXServicePage />} />
          <Route path="/service/seo-services" element={<SEOServicePage />} />
          <Route
            path="/it-strategy-planning"
            element={<ITStrategyConsultingPage />}
          />
          <Route
            path="/legacy-modernization"
            element={<LegacyModernizationPage />}
          />
          <Route
            path="/software-maintenance-support"
            element={<MaintenanceSupportPage />}
          />
          <Route
            path="/software-project-management"
            element={<ProjectManagementPage />}
          />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Suspense>
    </HelmetProvider>
  );
}

export default App;
